var defaultTimeFrameOptions = {
  threeMonths: {
    label: '3 months',
    sortOrder: 1
  },
  sixMonths: {
    label: '6 months',
    sortOrder: 2
  },
  oneYear: {
    label: '1 year',
    sortOrder: 3
  },
  twoYears: {
    label: '2 years',
    sortOrder: 4
  },
  threeYears: {
    label: '3 years',
    sortOrder: 5
  },
  fourYears: {
    label: '4 years',
    sortOrder: 6
  },
  fiveYears: {
    label: '5 years',
    sortOrder: 7
  },
  tenYears: {
    label: '10 years',
    sortOrder: 8
  }
};

export { defaultTimeFrameOptions };
//# sourceMappingURL=types.esm.js.map
